import { render, staticRenderFns } from "./OrdersScheduledPending.vue?vue&type=template&id=bc4c4660&scoped=true&"
import script from "./OrdersScheduledPending.vue?vue&type=script&lang=js&"
export * from "./OrdersScheduledPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4c4660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
